import './ManageAssignment.scss';
import React, {useEffect, useRef, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {FmlxTab} from 'fmlx-common-ui';
import {ManageAssignmentContext} from '../../lib/contexLib';
import SearchBoxes from './ManageAssignment/SearchBoxes';
import AssignmentTab from './ManageAssignment/AssignmentTab';
import ReviewedByTab from './ManageAssignment/ReviewedByTab';
import { getListProjectLead } from '../Dashboard/business/dashboardBusiness';

const ManageAssignment = () => {
  const {periodId, period} = useSelector((state) => ({
    periodId: state.appState.currentPeriod.id,
    period: state.appState.currentPeriod,
  }));

  const [selectedTab, setSelectedTab] = useState(0);
  const [departmentId, setDepartmentId] = useState(null);
  const [practiceId, setPracticeId] = useState(0);
  const [projectId, setProjectId] = useState(null);
  const [employeeName, setEmployeeName] = useState('');
  const [projectState, setProjectState] = useState([]);
  const [isDepartmentReady, setIsDepartmentReady] = useState(false);
  const [editReviewList, setEditReviewList] = useState([]);
  const selectedRowItemIdRef = useRef(null);

  const dispatch = useDispatch();

  const handleChange = ({index}) => {
    setSelectedTab(index);
  };

  useEffect(() => {
    (async () => {
      const projects = await dispatch(getListProjectLead());
      if (projects) {
        setProjectState(
          projects?.map((pj) => ({
            id: pj.id,
            text: pj.projectName,
            group: '',
            data: pj,
          }))
        );
      }
    })();
  }, [dispatch]);

  return (
    <div className="manageAssignmentPage">
      <ManageAssignmentContext.Provider
        value={{
          projectState,
          isDepartmentReady,
          setIsDepartmentReady,
          selectedTab,
          setSelectedTab,
          periodId,
          departmentId,
          setDepartmentId,
          practiceId,
          setPracticeId,
          projectId,
          setProjectId,
          employeeName,
          setEmployeeName,
          period,
          editReviewList,
          setEditReviewList,
          selectedRowItemIdRef,
        }}
      >
        <SearchBoxes />
        <FmlxTab
          selectedTab={selectedTab}
          onChange={handleChange}
           items={[
            {
              title: 'Assignment',
              content: <AssignmentTab />,
              icon: null,
              disabled: false,
            },
            {
              title: 'Reviewed by',
              content: <ReviewedByTab />,
              icon: null,
              disabled: false,
            },
          ]}
        />
      </ManageAssignmentContext.Provider>
    </div>
  );
};

export default ManageAssignment;
